import { useRef, useEffect } from "react";

/**
 * Adds a DOM event listener
 *
 * @param eventName
 * @param listener
 * @param element
 */
export function useEventListener<TEvent>(
  eventName: string,
  listener: (event: TEvent) => any,
  element?: HTMLElement | Document | Window | EventTarget,
) {
  const savedHandler = useRef(listener);
  useEffect(() => {
    savedHandler.current = listener;
  }, [listener]);

  useEffect(() => {
    const target = element || window;
    const isSupported = target.addEventListener;
    if (!isSupported) {
      // if (__DEV__) {
      console.warn("Event listener not supported on the element provided");
      // }
      return;
    }

    function eventListener(event: TEvent) {
      savedHandler.current(event);
    }

    target.addEventListener(eventName, eventListener as any);
    return () => {
      target.removeEventListener(eventName, eventListener as any);
    };
  }, [eventName, element]);
}
